// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combobox {
    border-color: var(--appbuilder-border-color);
}
    .combobox:hover {
        border-color: var(--appbuilder-hover-border-color);
    }

    .combobox:focus-within {
        border-color: var(--appbuilder-focus-border-color);
    }





`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/combobox/combobox.theme.control.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;AAChD;IACI;QACI,kDAAkD;IACtD;;IAEA;QACI,kDAAkD;IACtD","sourcesContent":[".combobox {\n    border-color: var(--appbuilder-border-color);\n}\n    .combobox:hover {\n        border-color: var(--appbuilder-hover-border-color);\n    }\n\n    .combobox:focus-within {\n        border-color: var(--appbuilder-focus-border-color);\n    }\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
